import React, { useState, useEffect } from "react";
import Icon from "../AppIcon";
import Button from "./Button";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("hero");

  const navigationItems = [
    { label: "Services", anchor: "services", offset: 80 },
    { label: "Pricing", anchor: "pricing", offset: 80 },
    { label: "Portfolio", anchor: "portfolio", offset: 80 },
    { label: "Process", anchor: "process", offset: 80 },
    { label: "About", anchor: "about", offset: 80 },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 100);

      // Update active section based on scroll position
      const sections = navigationItems.map((item) => item.anchor);
      const currentSection = sections.find((section) => {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          return rect.top <= 100 && rect.bottom >= 100;
        }
        return false;
      });

      if (currentSection) {
        setActiveSection(currentSection);
      } else if (scrollPosition < 100) {
        setActiveSection("hero");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (anchor, offset = 80) => {
    const element = document.getElementById(anchor);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
    setIsMenuOpen(false);
  };

  const handleContactClick = () => {
    const element = document.getElementById("contact");
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 80;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
    setIsMenuOpen(false);
  };

  return (
    <>
      {/* Main Header */}
      <header className="bg-background border-b border-border relative z-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex-shrink-0">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center mr-3">
                  <Icon name="Zap" size={20} color="white" />
                </div>
                <span className="text-xl font-bold font-inter text-text-primary">
                  FreelanceHub
                </span>
              </div>
            </div>

            {/* Desktop Navigation */}
            {/* <nav className="hidden md:flex items-center space-x-8">
              {navigationItems.map((item) => (
                <button
                  key={item.anchor}
                  onClick={() => handleNavClick(item.anchor, item.offset)}
                  className={`text-sm font-medium font-inter transition-smooth hover:text-primary ${
                    activeSection === item.anchor
                      ? 'text-primary' :'text-text-secondary'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </nav> */}

            {/* Desktop Auth Buttons */}
            <div className="hidden md:flex items-center space-x-3">
              <Button
                onClick={() =>
                  (window.location.href = "http://localhost:3001/login")
                }
                variant="ghost"
                size="sm"
                className="font-poppins font-medium text-text-secondary "
              >
                Login
              </Button>

              <Button
                onClick={() =>
                  (window.location.href = "http://localhost:3001/register")
                }
                variant="default"
                size="sm"
                className="font-poppins font-semibold shadow-cta"
              >
                Sign Up
              </Button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-text-secondary hover:text-primary hover:bg-surface transition-smooth"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                <Icon name={isMenuOpen ? "X" : "Menu"} size={24} />
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-background border-b border-border shadow-card z-200">
            <div className="px-4 pt-2 pb-3 space-y-1">
              {/* {navigationItems.map((item) => (
                <button
                  key={item.anchor}
                  onClick={() => handleNavClick(item.anchor, item.offset)}
                  className={`block w-full text-left px-3 py-2 text-base font-medium font-inter transition-smooth hover:text-primary hover:bg-surface rounded-md ${
                    activeSection === item.anchor
                      ? "text-primary bg-surface"
                      : "text-text-secondary"
                  }`}
                >
                  {item.label}
                </button>
              ))} */}
              <div className="pt-4 pb-2 space-y-2">
                 <Button
                onClick={() =>
                  (window.location.href = "http://localhost:3001/login")
                }
                variant="ghost"
                size="sm"
                className="font-poppins font-medium text-text-secondary "
              >
                Login
              </Button>
                <Button
                onClick={() =>
                  (window.location.href = "http://localhost:3001/register")
                }
                variant="default"
                size="sm"
                className="font-poppins font-semibold shadow-cta"
              >
                Sign Up
              </Button>
              </div>
            </div>
          </div>
        )}
      </header>

      {/* Sticky Navigation Bar */}
      {isScrolled && (
        <div className="fixed top-0 left-0 right-0 bg-background/95 backdrop-blur-sm border-b border-border z-100 animate-slide-down">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-14">
              {/* Compact Logo */}
              <div className="flex items-center">
                <div className="w-6 h-6 bg-primary rounded-md flex items-center justify-center mr-2">
                  <Icon name="Zap" size={14} color="white" />
                </div>
                <span className="text-lg font-bold font-inter text-text-primary">
                  FreelanceHub
                </span>
              </div>

              {/* Compact Navigation */}
              {/* <nav className="hidden md:flex items-center space-x-6">
                {navigationItems.map((item) => (
                  <button
                    key={item.anchor}
                    onClick={() => handleNavClick(item.anchor, item.offset)}
                    className={`text-sm font-medium font-inter transition-smooth hover:text-primary ${
                      activeSection === item.anchor
                        ? "text-primary"
                        : "text-text-secondary"
                    }`}
                  >
                    {item.label}
                  </button>
                ))}
              </nav> */}

              {/* Compact Auth Buttons */}
              <div className="flex items-center space-x-2">
                 <Button
                onClick={() =>
                  (window.location.href = "http://localhost:3001/login")
                }
                variant="ghost"
                size="sm"
                className="font-poppins font-medium text-text-secondary "
              >
                Login
              </Button>
                <Button
                onClick={() =>
                  (window.location.href = "http://localhost:3001/register")
                }
                variant="default"
                size="sm"
                className="font-poppins font-semibold shadow-cta"
              >
                Sign Up
              </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Section Progress Indicator - Desktop */}
      <div className="hidden lg:block fixed left-6 top-1/2 transform -translate-y-1/2 z-90">
        <div className="flex flex-col space-y-3">
          {["hero", ...navigationItems.map((item) => item.anchor)].map(
            (section, index) => (
              <button
                key={section}
                onClick={() =>
                  handleNavClick(section, section === "hero" ? 0 : 80)
                }
                className={`w-3 h-3 rounded-full transition-smooth ${
                  activeSection === section
                    ? "bg-primary scale-125"
                    : "bg-border hover:bg-text-secondary"
                }`}
                title={
                  section === "hero"
                    ? "Top"
                    : navigationItems.find((item) => item.anchor === section)
                        ?.label
                }
              />
            )
          )}
        </div>
      </div>

      {/* Section Progress Indicator - Mobile */}
      <div className="lg:hidden fixed bottom-4 left-4 right-4 z-90">
        <div className="bg-background/95 backdrop-blur-sm rounded-full px-4 py-2 shadow-card border border-border">
          <div className="flex justify-between items-center">
            {["hero", ...navigationItems.map((item) => item.anchor)].map(
              (section, index) => (
                <button
                  key={section}
                  onClick={() =>
                    handleNavClick(section, section === "hero" ? 0 : 80)
                  }
                  className={`w-2 h-2 rounded-full transition-smooth ${
                    activeSection === section
                      ? "bg-primary scale-150"
                      : "bg-border"
                  }`}
                />
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
